export enum ScreenSizeType {
  'SuperExtraLarge' = 'SuperExtraLarge',
  'ExtraLarge' = 'ExtraLarge',
  'Large' = 'Large',
  'Medium' = 'Medium',
  'Small' = 'Small',
  'ExtraSmall' = 'ExtraSmall',
}

const SUPER_EXTRA_LARGE_BREAKPOINT = 2048;
const EXTRA_LARGE_BREAKPOINT = 1536;
const LARGE_BREAKPOINT = 1200;
const MEDIUM_BREAKPOINT = 900;
const SMALL_BREAKPOINT = 600;
const EXTRA_SMALL_BREAKPOINT = 0;

export const SCREEN_BREAKPOINTS: Record<ScreenSizeType, number> = {
  [ScreenSizeType.SuperExtraLarge]: SUPER_EXTRA_LARGE_BREAKPOINT,
  [ScreenSizeType.ExtraLarge]: EXTRA_LARGE_BREAKPOINT,
  [ScreenSizeType.Large]: LARGE_BREAKPOINT,
  [ScreenSizeType.Medium]: MEDIUM_BREAKPOINT,
  [ScreenSizeType.Small]: SMALL_BREAKPOINT,
  [ScreenSizeType.ExtraSmall]: EXTRA_SMALL_BREAKPOINT,
};
